/** Caption sits centered above the logo track. */
export const PARTNER_LOGO_CAPTION_CLASS =
	"m-0 w-full max-w-full min-w-0 text-center text-landing-caption font-medium text-teal-500 max-md:text-[11px]";

/** Layout (grid, gap, margin) lives in `partner-logos.css` so Webflow `ul` tags cannot collapse it. */
export const PARTNER_LOGO_ROW_CLASS = "w-full list-none";

export const PARTNER_LOGO_IMAGE_CLASS = "block h-8 w-auto max-w-full object-contain object-center md:h-9";
